<div class="viewer-container">
  <rdrx-modal-header [withClose]="false">
    <h1
      class="dialog-heading"
      cdkDrag
      cdkDragRootElement=".cdk-overlay-pane"
      cdkDragHandle
      id="global-wiris-modal-h1"
      >
      {{ title }}
    </h1>
  </rdrx-modal-header>
  <div class="body js-wiris-editor-container wiris-dialog"></div>
  @if (error$ | async) {
    <div class="message-error">
      <mhe-alert data-automation-id="global-wiris-error-alert" [type]="alertType.Error" [closable]="false">
        {{ 'dialog.failed_message' | translate }}
      </mhe-alert>
    </div>
  }
  <rdrx-modal-footer class="action-bar">
    <div class="action-group">
      <button
        data-automation-id="wiris-cancel-button"
        mhe-button
        [purpose]="ButtonPurpose.Secondary"
        class="action-item action-button"
        [attr.aria-label]="'dialog.cancel' | translate"
        (click)="closeDialog(false)"
        >
        Cancel
      </button>
      <button
        data-automation-id="wiris-accept-button"
        mhe-button
        [purpose]="ButtonPurpose.Primary"
        class="action-item action-button"
        [attr.aria-label]="'dialog.accept' | translate"
        (click)="closeDialog(true)"
        >
        Accept
      </button>
    </div>
  </rdrx-modal-footer>
</div>
